<template lang="pug">
.skeleton-circle.s-24
</template>

<style scoped src="./skeleton.css"></style>
